import axios from '@/api/axiosInstance';

export default async function getClassTheme(classId, themeId) {
  const response = await axios({
    method: 'get',
    url: `${process.env.NEXT_PUBLIC_API}/classes/${classId}/themes/${themeId}`,
  });
  return response.data;
}
